(function (_) {
    'use strict';

    _['LOYALTY.KEY'] = 'Fidelización';
    _['LOYALTY.EMPTY-LIST'] = 'No hay tarjetas de fidelización activas en este momento.';
    _['LOYALTY.VALID-FROM'] = 'Desde: ';
    _['LOYALTY.VALID-UNTIL'] = 'Hasta: ';
    _['LOYALTY.NO-LIMIT'] = 'Sin límite';
    _['LOYALTY.CONDITIONS'] = 'Condiciones';
    _['LOYALTY.CANCEL'] = 'Cancelar';
    _['LOYALTY.ACCEPT'] = 'Aceptar';
    _['LOYALTY.EXCEPTIONS-TITLE'] = 'Excepciones';
    _['LOYALTY.PERIOD-VALIDITY'] = 'Periodo de validez';
    _['LOYALTY.HOW-STAMP-TITLE'] = 'Como estampar: ';
    _['LOYALTY.HOW-STAMP-CONTENT'] = 'Mostrar el QR para ser escaneado o introducir el código en la casilla de validación.';
    _['LOYALTY.HOW-STAMP-CONTENT-ONLY-CODE'] = 'Por favor, introduce el código en la casilla de validación.';
    _['LOYALTY.DAILY-LIMIT'] = 'Has superado el límite diario.';
    _['LOYALTY.VALID-CODE'] = 'Codigo válido';
    _['LOYALTY.INVALID-CODE'] = 'Codigo inválido';
    _['LOYALTY.GIFT-FREEBIENAME'] = '¡Enhorabuena! Tienes gratis un:';
    _['LOYALTY.CODE-PLACEHOLDER'] = 'Introduce Código';

}(translations['es']));



// WEBPACK FOOTER //
// ./src/app/modules/loyalty/lang/loyalty-lang_es.js